module.exports = __webpack_public_path__ + "img/img-cropper.e6b26f04.jpg";